import { useContext } from 'react';

import { useQuery } from '@apollo/client';
import {
  PUBLIC_GET_BETRIEBSARTEN_QUERY,
  PUBLIC_GET_CRAFTCHAMBERS_QUERY,
  PUBLIC_GET_GRIDNET_PROVIDERS_QUERY,
} from 'Queries/Queries';
import { ErrorHandlingContext } from 'context/ErrorHandling';

import { PUBLIC_NO_AUTH_CONFIG } from 'components/ApolloComponent/Apollo';

import {
  getComboBoxOptionsForBetriebsarten,
  getComboBoxOptionsForCraftChamber,
  getComboBoxOptionsForGridnetProviders,
} from 'utils/FormUtils';

export const useFormUtilityData = () => {
  const { setShowError } = useContext(ErrorHandlingContext);
  const {
    data,
    loading: isGridnetProvidersLoading,
    error: gridnetProvidersError,
  } = useQuery(PUBLIC_GET_GRIDNET_PROVIDERS_QUERY, {
    fetchPolicy: 'cache-first',
    nextFetchPolicy: 'cache-only',
    onError: (error) => {
      if (!error) return;

      console.error('gridnet providers error:', error);
      setShowError((prev) => !prev && true);
    },
    ...PUBLIC_NO_AUTH_CONFIG,
  });
  const {
    data: craftChamberData,
    loading: isCraftChamberLoading,
    error: craftChamberError,
  } = useQuery(PUBLIC_GET_CRAFTCHAMBERS_QUERY, {
    fetchPolicy: 'cache-first',
    nextFetchPolicy: 'cache-only',
    onError: (error) => {
      if (!error) return;

      console.error('craftChamber error:', error);
      setShowError((prev) => !prev && true);
    },
    ...PUBLIC_NO_AUTH_CONFIG,
  });
  const {
    data: betriebsartenData,
    loading: isBetriebsartenLoading,
    error: betriebsartenError,
  } = useQuery(PUBLIC_GET_BETRIEBSARTEN_QUERY, {
    fetchPolicy: 'cache-first',
    nextFetchPolicy: 'cache-only',
    onError: (error) => {
      if (!error) return;

      console.error('betriebsarten error:', error);
      setShowError((prev) => !prev && true);
    },
    ...PUBLIC_NO_AUTH_CONFIG,
  });

  const gridnetProviders = data?.getGridNetProviders ?? [];
  const craftChamber = craftChamberData?.getCraftChamberAreas ?? [];
  const betriebsarten = betriebsartenData?.getBetriebsarten ?? [];

  const isLoading = isGridnetProvidersLoading || isCraftChamberLoading || isBetriebsartenLoading;

  return {
    comboBoxOptions: {
      craftsChamberArea: getComboBoxOptionsForCraftChamber(craftChamber),
      gridProviderEnergy: getComboBoxOptionsForGridnetProviders(gridnetProviders),
      gridProviderGas: getComboBoxOptionsForGridnetProviders(gridnetProviders),
      taetigkeitsschwerpunkt: getComboBoxOptionsForBetriebsarten(betriebsarten),
    },
    isLoading,
    gridnetProviders,
    isGridnetProvidersLoading,
    isGridnetProvidersError: gridnetProvidersError,
    craftChamber,
    isCraftChamberLoading,
    isCraftChamberError: craftChamberError,
    betriebsarten,
    isBetriebsartenLoading,
    isBetriebsartenError: betriebsartenError,
  };
};
